/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import * as FeatureFlags from '@carbon/feature-flags';
import HeaderNavigationClassic from './HeaderNavigation';
import { HeaderNavigation as HeaderNavigationNext } from './next';
import SideNavMenuClassic from './SideNavMenu';
import { SideNavMenu as SideNavMenuNext } from './next/SideNavMenu';
import _Content from './Content';
export { _Content as Content };
import _Header from './Header';
export { _Header as Header };
import _HeaderContainer from './HeaderContainer';
export { _HeaderContainer as HeaderContainer };
import _HeaderGlobalAction from './HeaderGlobalAction';
export { _HeaderGlobalAction as HeaderGlobalAction };
import _HeaderGlobalBar from './HeaderGlobalBar';
export { _HeaderGlobalBar as HeaderGlobalBar };
import _HeaderMenu from './HeaderMenu';
export { _HeaderMenu as HeaderMenu };
import _HeaderMenuButton from './HeaderMenuButton';
export { _HeaderMenuButton as HeaderMenuButton };
import _HeaderMenuItem from './HeaderMenuItem';
export { _HeaderMenuItem as HeaderMenuItem };
import _HeaderName from './HeaderName';
export { _HeaderName as HeaderName };
export var HeaderNavigation = FeatureFlags.enabled('enable-v11-release') ? HeaderNavigationNext : HeaderNavigationClassic;
import _HeaderPanel from './HeaderPanel';
export { _HeaderPanel as HeaderPanel };
import _HeaderSideNavItems from './HeaderSideNavItems';
export { _HeaderSideNavItems as HeaderSideNavItems };
import _Switcher from './Switcher';
export { _Switcher as Switcher };
import _SwitcherItem from './SwitcherItem';
export { _SwitcherItem as SwitcherItem };
import _SwitcherDivider from './SwitcherDivider';
export { _SwitcherDivider as SwitcherDivider };
import _SkipToContent from './SkipToContent';
export { _SkipToContent as SkipToContent };
import _SideNav from './SideNav';
export { _SideNav as SideNav };
import _SideNavDetails from './SideNavDetails';
export { _SideNavDetails as SideNavDetails };
import _SideNavDivider from './SideNavDivider';
export { _SideNavDivider as SideNavDivider };
import _SideNavFooter from './SideNavFooter';
export { _SideNavFooter as SideNavFooter };
import _SideNavHeader from './SideNavHeader';
export { _SideNavHeader as SideNavHeader };
import _SideNavIcon from './SideNavIcon';
export { _SideNavIcon as SideNavIcon };
import _SideNavItem from './SideNavItem';
export { _SideNavItem as SideNavItem };
import _SideNavItems from './SideNavItems';
export { _SideNavItems as SideNavItems };
import _SideNavLink from './SideNavLink';
export { _SideNavLink as SideNavLink };
import _SideNavLinkText from './SideNavLinkText';
export { _SideNavLinkText as SideNavLinkText };
export var SideNavMenu = FeatureFlags.enabled('enable-v11-release') ? SideNavMenuNext : SideNavMenuClassic;
import _SideNavMenuItem from './SideNavMenuItem';
export { _SideNavMenuItem as SideNavMenuItem };
import _SideNavSwitcher from './SideNavSwitcher';
export { _SideNavSwitcher as SideNavSwitcher };